export default (promsises, progressCallback) => {
  let d = 0;
  progressCallback(0);
  for (const promise of promsises) {
    // eslint-disable-next-line
    promise.then(() => {    
      d+=1;
      progressCallback((d * 100) / promsises.length);
    });
  }
  return Promise.all(promsises);
}
